import Angular from "angular";
import Controller from "./booking-details.controller";
import Template from "./booking-details.html";
import Bookings from "../../services/bookings.service";
import BookingDetails from "../../components/booking-details/booking-details";

export const BookingDetailsView = {
    template: Template,
    controller: Controller,
    controllerAs: '$ctrl'
};

export default Angular.module('view.booking-details', [
    Bookings.name,
    BookingDetails.name
]);



// WEBPACK FOOTER //
// ./src/modules/main/views/booking-details/booking-details.js